import $ from "jquery";
import lightbox from 'lightbox2';

const lightboxScript = {
  initLightbox: () => {
    lightbox.option({
      'resizeDuration': 200,
      'disableScrolling': true,
      'showImageNumberLabel': false,
    })
  }
}


export default lightboxScript;